import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 20,
      },
    },
    border: `5px dashed ${theme.highlightColor}`,
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "28pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    paddingBottom: 10,
  },
  SUBHEADLINE: {
    textAlign: "center",
    fontSize: "22pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    paddingBottom: 10,
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: "20px 0",
  },
  BUTTON: {
    style: {
      display: "inline-block",
      textAlign: "center",
      marginTop: 20,
      mobile: {
        desktop: {
          padding: "15px 75px",
        },
        mobile: {
          padding: 5,
        },
      },
      border: "none",
      backgroundColor: theme.backgroundColor,
      // minWidth: 125,
      // width: "100%",
      borderRadius: 3,
      cursor: "pointer",
      margin: "50px auto 0",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "16pt",
    },
    caption2: {
      color: theme.foregroundColor,
      opacity: 0.5,
      // fontWeight: "bold" as "bold",
      fontSize: "12pt",
    },
  },
  COUNTDOWN: {
    style: {
      margin: "0 auto",
      display: "inline-block",
    },
    dimensionStyle: {
      minWidth: 75,
    },
    numberStyle: {
      textAlign: "center",
      fontSize: "26pt",
      fontFamily: theme.fontFamily,
      fontWeight: "bold" as "bold",
      padding: 10,
      backgroundColor: theme.backgroundColor,
      color: theme.foregroundColor,
      margin: 5,
    },
    labelStyle: {
      fontWeight: "bold" as "bold",
      fontFamily: theme.fontFamily,
    },
    dividerStyle: {
      padding: 10,
      fontWeight: "bold" as "bold",
      fontFamily: theme.fontFamily,
    },
  },
};
